import {
  IDENTITY,
  RECENT_CHAT,
  CHAT_HISTORY,
  SELECTED_CHAT,
  CHAT_SENT_ACK,
  USER_ONLINE,
  GET_GIF,
  GET_DETAILED_GIF,
  START_TYPING_ACK,
  STOP_TYPING_ACK,
  CHAT_RECEIVED,
  REMOVE_MESSAGE,
  OPEN,
  IS_USER_ONLINE,
  READ_ALL_MESSAGES,
  BUSINESS_CHAT_RECEIVED,
  BUSINESS_CHAT_HISTORY,
  BUSINESS_DELETE_MESSAGE,
  ERROR,
  HIDE_POP_UP,
  DELETE_CHAT,
  ALL_LIVE_CHAT,
  LIVE_CHAT_SENT_MESSAGE_ACK,
  LIVE_CHAT_REMOVE_BUSINESS_MESSAGE,
  LIVE_CHAT_UPDATE_RECENT_CHAT,
  SET_SCROLL,
  UNREAD_COUNT,
  CLEAR_GIF,
  INCREASE_MESSAGE_INDEX,
  UPDATE_RECENT_CHAT,
  CLEAR_ALL_DATA,
  GET_DIALOG,
  REMOVE_EMPTY_DIALOG,
  UNSELECT_CHAT,
  INITIAL_LOAD,
  EMPTY_BACKUP_CHAT,
  TOGGLE_DRAWER,
  TOGGLE_POPUP,
  ADD_TOAST,
  ON_CLICK_TOAST,
  EMPTY_LIVE_CHAT,
} from "./actionTypes";
import axios from "axios";
import axiosI from "../Service/service";
import storeFolder from "../store";
import { routeName } from "../../src/Service/env";
import { ws } from "../App";
import addNotification from "react-push-notification";
import { convertUnicode } from "../Helper/methods";
import { history } from "../store";
import React from "react";
import { IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

export const messageAction = (data) => {
  return async (dispatch) => {
    let storeData = storeFolder.getState();
    let response = JSON.parse(data.data);
    switch (response.type) {
      case "getdialog":
        const messageChatData = {
          dialog_id: response.dialog_id,
          last_message_json: {},
          utc_message_date: "",
          UserName: localStorage.getItem("curbsideCommunicationUserName"),
          userid: localStorage.getItem("curbsideCommunicationUserId"),
          locatoinInfo: null,
          photo: "",
          FullName: localStorage.getItem("curbsideCommunicationFullName"),
          Bio: "",
          unread_count: 0,
          from_user_id: storeData.loginResponse.results.AppUser.UserId,
          IsOnlyFriendsMsgMe: "",
          IsAccountPrivate: "",
          Type: "OneToOne",
          EventId: null,
          FeedId: null,
          RowNumber: storeData.messageReducer.recentChat.length,
        };
        dispatch({
          type: GET_DIALOG,
          payload: messageChatData,
        });
        break;
      case "identity":
        dispatch({
          type: IDENTITY,
          payload: response,
        });
        break;
      case "recentChat":
        if (
          storeData.messageReducer.chatHistory &&
          storeData.messageReducer.chatHistory.length === 0
        ) {
          ws.json({
            count: 20,
            deleteCount: 0,
            dialog_id: response.chats,
            index: 1,
            type: "chatHistory",
            user_id: storeData.loginResponse.results.AppUser.UserId,
          });
        }
        dispatch({
          type: RECENT_CHAT,
          payload: response,
        });
        break;
      case "chatHistory":
        dispatch({
          type: CHAT_HISTORY,
          payload: response,
        });
        getUnreadCount()(dispatch);
        break;
      case "chatsentack":
        dispatch({
          type: CHAT_SENT_ACK,
          payload: response,
        });
        break;
      case "userOnline":
        dispatch({
          type: USER_ONLINE,
          payload: response,
        });
        break;
      case "starttypingack":
        dispatch({
          type: START_TYPING_ACK,
          payload: response,
        });
        break;
      case "stoptypingack":
        dispatch({
          type: STOP_TYPING_ACK,
          payload: response,
        });
        break;
      case "chat":
        if (storeData.messageReducer.selectedChat) {
          if (
            storeData.messageReducer.selectedChat.dialog_id.toUpperCase() ===
              response.dialog_id.toUpperCase() &&
            window.location.pathname === `/${routeName}/Dashboard/Messages`
          ) {
            ws.json({
              chat_id: response.chat_id,
              type: "chatrecieveack",
              user_id: storeData.loginResponse.results.AppUser.UserId,
            });
          }
          getUnreadCount()(dispatch);
        } else {
          ws.json({
            user_id: storeData.loginResponse.results.AppUser.UserId,
            type: "recentchat",
            count: 20,
            index: 1,
          });
        }
        if (
          localStorage.getItem("UserId") &&
          !document.location.toString().includes("Messages")
        ) {
          var message = response.chat_message.text;
          if (message === "[Sticker message]") {
            message = "Sound Moji Received";
          } else if (message === "[Picture message]") {
            message = "Picture Received";
          } else if (message === "[GIF message]") {
            message = "GIF Received";
          } else {
            message = convertUnicode(message);
          }

          let onlineOrderFormId = storeData.loginResponse.results.BusinessUser.OnlineOrderFormId

          if ((onlineOrderFormId !== null && onlineOrderFormId !== "" &&  storeData.messageReducer.messagePopUpStatus) || (onlineOrderFormId === null || onlineOrderFormId === "")) {
            if ((storeData.messageReducer.drawerStatus && storeData.messageReducer.selectedChat.dialog_id.toUpperCase() !== response.dialog_id.toUpperCase()) || !storeData.messageReducer.drawerStatus) {
              // if (!document.hasFocus()) {
              //   addNotification({
              //     title: response.FullName,
              //     message: message,
              //     theme: "red",
              //     native: true, // true : "Browser Notification" , False "Custom Notification"
              //     backgroundTop: "#BF2129", //'#A534A6', //optional, background color of top container.
              //     backgroundBottom: "#d82c33", //'#b764ac', //optional, background color of bottom container.
              //     silent: true,
              //     duration: 1000 * 60 * 60 * 24 * 7,
              //     closeButton: <CloseIcon/>,
              //     onClick: function () {
              //       console.log("view notification message action");
              //       window.focus();
              //       setInitial("OneToOne");
              //       toggleDrawer(true, false)(dispatch);
              //       dispatch({
              //         type: ON_CLICK_TOAST,
              //         payload: response,
              //       });
              //       console.log("view notification message action done");
              //     },
              //   });
              // } else {
                const id = Math.floor(Math.random() * 101 + 1);

                const toastProperties = {
                  id,
                  title: response.FullName,
                  description: message,
                  backgroundColor: "#d82c33",
                  theme: "red",
                  backgroundTop: "#BF2129", //'#A534A6', //optional, background color of top container.
                  backgroundBottom: "#d82c33", //'#b764ac', //optional, background color of bottom container.
                  closeButton: <CloseIcon />,
                  onClick: () => {
                    setInitial("OneToOne");
                    toggleDrawer(true, false)(dispatch);
                    dispatch({
                      type: ON_CLICK_TOAST,
                      payload: response,
                    });
                  },
                };

                AddToast([...storeData.messageReducer.toastList, toastProperties])(
                    dispatch
                );
              // }
            }
          }
        }

        dispatch({
          type: CHAT_RECEIVED,
          payload: response,
        });
        break;
      case "removemessage":
        ws.json({
          user_id: localStorage.getItem("UserId"),
          type: "recentchat",
          count: 20,
          index: 1,
        });
        getUnreadCount()(dispatch);
        dispatch({
          type: REMOVE_MESSAGE,
          payload: response,
        });
        break;
      case "ackUserStatus":
        dispatch({
          type: IS_USER_ONLINE,
          payload: response,
        });
        break;
      case "businessrecentchat":
        if (response.MainQuestionId) {
          dispatch({
            type: BUSINESS_CHAT_HISTORY,
            payload: response,
          });
        } else {
          dispatch({
            type: ALL_LIVE_CHAT,
            payload: response,
          });
        }
        break;
      case "businesschat":
        if (
          storeData.messageReducer.selectedChat &&
          storeData.messageReducer.selectedChat.dialog_id.toUpperCase() ===
            response.googlePlacedId.toUpperCase()
        ) {
          ws.json({
            chat_id: response.chat_id,
            type: "chatrecieveack",
            user_id: storeData.loginResponse.results.AppUser.UserId,
          });
        }
        getUnreadCount()(dispatch);

        if (response.chat_type === "Business") {
          dispatch({
            type: LIVE_CHAT_SENT_MESSAGE_ACK,
            payload: response,
          });
        } else {
          let onlineOrderFormId = storeData.loginResponse.results.BusinessUser.OnlineOrderFormId
          if ((onlineOrderFormId !== null && onlineOrderFormId !== "" &&  storeData.messageReducer.messagePopUpStatus) || (onlineOrderFormId === null || onlineOrderFormId === "")) {
            if (storeData.loginResponse.results.AppUser.UserId !== response.user_id) {
              if ((storeData.messageReducer.drawerStatus && ((response.chat_type && storeData.messageReducer.selectedChat.Type) !== "PlaceQuestionChat")) || (storeData.messageReducer.drawerStatus && (((response.chat_type && storeData.messageReducer.selectedChat.Type) === "PlaceQuestionChat") && (response.user_id !== storeData.messageReducer.selectedChat.userid))) || (!storeData.messageReducer.drawerStatus)) {
                // if (!document.hasFocus()) {
                //   addNotification({
                //     title: response.chat_type === 'PlaceQuestionChat' ? response.firstname.trim() + "'s Question" : response.firstname,
                //     message: response.chat_message.text,
                //     theme: "red",
                //     native: true, // true : "Browser Notification" , False "Custom Notification"
                //     backgroundTop: "#BF2129", //'#A534A6', //optional, background color of top container.
                //     backgroundBottom: "#d82c33", //'#b764ac', //optional, background color of bottom container.
                //     silent: true,
                //     duration: 1000 * 60 * 60 * 24 * 7,
                //     closeButton: <CloseIcon/>,
                //     onClick: function () {
                //       console.log("view notification message action");
                //       window.focus();
                //       setInitial("QuestionChat");
                //       toggleDrawer(true, false)(dispatch);
                //       dispatch({
                //         type: ON_CLICK_TOAST,
                //         payload: response,
                //       });
                //       console.log("view notification message action done");
                //     },
                //   });
                // } else {
                  const id = Math.floor(Math.random() * 101 + 1);

                  const toastProperties = {
                    id,
                    title: response.chat_type === 'PlaceQuestionChat' ? response.firstname.trim() + "'s Question" : response.firstname,
                    description: response.chat_message.text,
                    backgroundColor: "#d82c33",
                    theme: "red",
                    backgroundTop: "#BF2129", //'#A534A6', //optional, background color of top container.
                    backgroundBottom: "#d82c33", //'#b764ac', //optional, background color of bottom container.
                    closeButton: <CloseIcon/>,
                    onClick: () => {
                      setInitial("QuestionChat");
                      toggleDrawer(true, false)(dispatch);
                      dispatch({
                        type: ON_CLICK_TOAST,
                        payload: response,
                      });
                    },
                  };

                  AddToast([...storeData.messageReducer.toastList, toastProperties])(
                      dispatch
                  );
                // }
              }
            }
          }

          dispatch({
            type: BUSINESS_CHAT_RECEIVED,
            payload: response,
          });
        }
        break;
      case "ackDeleteChat":
        dispatch({
          type: DELETE_CHAT,
          payload: response,
        });
        break;
      case "participantACK":
        break;
      case "ackRemoveBusinessMessage":
        dispatch({
          type: LIVE_CHAT_REMOVE_BUSINESS_MESSAGE,
          payload: response,
        });
        break;
      case "chatstatusupdated":
        break;
      case "updateRecentChat":
        if (
          storeData.messageReducer.selectedChat.dialog_id.toUpperCase() ===
          response.googlePlacedId.toUpperCase()
        ) {
          ws.json({
            chat_id: response.chat_id,
            type: "chatrecieveack",
            user_id: storeData.loginResponse.results.AppUser.UserId,
          });
        } else {
          getUnreadCount()(dispatch);
        }

        if (response && response.chat_type && response.chat_type === 'Feed') {
          dispatch({
            type: LIVE_CHAT_UPDATE_RECENT_CHAT,
            payload: response,
          });
        }

        // dispatch({
        //   type: UPDATE_RECENT_CHAT,
        //   payload: response,
        // });

        break;
      default:
        break;
    }
  };
};

export const removeEmptyDialog = (data) => {
  return (dispatch) => {
    dispatch({
      type: REMOVE_EMPTY_DIALOG,
      payload: data,
    });
  };
};

export const emptyBackupChat = (data) => {
  return (dispatch) => {
    dispatch({
      type: EMPTY_BACKUP_CHAT,
      payload: data,
    });
  };
};

export const emptyLiveChat = (data) => {
  return (dispatch) => {
    dispatch({
      type: EMPTY_LIVE_CHAT,
      payload: data,
    });
  };
};

export const unselectChat = (data) => {
  return (dispatch) => {
    dispatch({
      type: UNSELECT_CHAT,
      payload: data,
    });
  };
};

export const selectedChat = (data) => {
  return (dispatch) => {
    dispatch({
      type: SELECTED_CHAT,
      payload: data,
    });

    let storeData = storeFolder.getState();
    if (data.Type !== "PlaceQuestionChat") {
      dispatch({
        type: READ_ALL_MESSAGES,
        payload: data,
      });
    }
  };
};
export const getGIF = (url) => {
  return (dispatch) =>
    axios
      .post(url)
      .then((response) => {
        dispatch({
          type: GET_GIF,
          payload: response.data.tags,
        });
      })
      .catch((err) => {
        console.log(err);
      });
};
export const getDetailGIF = (data) => {
  return (dispatch) =>
    axios
      .post(
        `https://api.tenor.co/v1/search?key=RH3P1OZMBSCK&tag=${data.name}k&pos=${data.page}`
      )
      .then((response) => {
        dispatch({
          type: GET_DETAILED_GIF,
          payload: response.data,
        });
      })
      .catch((err) => {
        console.log("Error getting detailed GIF.", err);
        error("No Internet Connection")(dispatch);
      });
};
export const deleteMessage = (data) => {
  return (dispatch) =>
    dispatch({
      type: REMOVE_MESSAGE,
      payload: {
        chatId: data,
      },
    });
};
export const readAllMessages = (data) => {
  return (dispatch) =>
    dispatch({
      type: READ_ALL_MESSAGES,
      payload: data,
    });
};
export const deleteBusinessMessage = (data) => {
  return (dispatch) =>
    dispatch({
      type: BUSINESS_DELETE_MESSAGE,
      payload: data,
    });
};
export const onOpen = () => {
  return (dispatch) => {
    dispatch({
      type: OPEN,
    });
  };
};
export const setInitial = (type) => {
  return (dispatch) =>
    dispatch({
      type: INITIAL_LOAD,
      payload: type,
    });
};
export const error = (message) => {
  return (dispatch) => {
    dispatch({
      type: ERROR,
      payload: {
        message: message,
      },
    });
  };
};

export const hidePopUp = () => {
  return (dispatch) => {
    dispatch({
      type: HIDE_POP_UP,
      payload: false,
    });
  };
};

export const setScrollFalse = () => {
  return (dispatch) => {
    dispatch({
      type: SET_SCROLL,
      payload: false,
    });
  };
};

export const getUnreadCount = () => {
  return (dispatch) => {
    let data = localStorage.getItem("UserId");
    axiosI
      .get(`GetCountByStatus/${data}/${data}/Pending`)
      .then((response) => {
        dispatch({
          type: UNREAD_COUNT,
          payload: response.data.results,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
};
export const clearDetailedGif = () => {
  return (dispatch) =>
    dispatch({
      type: CLEAR_GIF,
    });
};
export const increaseMessageIndex = (data) => {
  return (dispatch) =>
    dispatch({
      type: INCREASE_MESSAGE_INDEX,
      payload: data,
    });
};

export const clearData = (data) => {
  return (dispatch) =>
    dispatch({
      type: CLEAR_ALL_DATA,
      payload: data,
    });
};

export const unreadCountToZero = (data) => {
  return (dispatch) =>
    axiosI
      .get(`/SetChatAsRead/${data}`)
      .then((response) => {
        getUnreadCount()(dispatch);
      })
      .catch((err) => {
        console.log(err);
      });
};

export const toggleDrawer = (data, showAllMessages) => {
  return (dispatch) => {
    dispatch({
      type: TOGGLE_DRAWER,
      payload: { data, showAllMessages: showAllMessages },
    });
  };
};

export const togglePopUp = (data) => {
  return (dispatch) => {
    dispatch({
      type: TOGGLE_POPUP,
      payload: data,
    });
  };
};

export const AddToast = (data) => {
  return (dispatch) => {
    dispatch({
      type: ADD_TOAST,
      payload: data,
    });
  };
};
